import { FC } from 'react';
import { Spin } from '@bfe/moly';
import { Block } from '@/components/block';
import { useScreenType } from '@web3/base-hooks';
import { useCurrentWallet } from '@web3fe/infra';
import { Connected } from './connected';
import { UnConnected } from './unConnected';
import { Banners } from './banners';

import 'swiper/css';
import 'swiper/css/pagination';

import styles from './index.module.scss';

export const Banner: FC = () => {
  const walletInfo = useCurrentWallet();

  const { isMobile } = useScreenType();
  const isWalletConnected = !walletInfo.isNone;

  return (
    <Block clsName={styles.bannerWrapper} noHeader>
      <Spin spinning={false}>
        <div className={styles.banner}>
          {isWalletConnected && !isMobile ? <Connected /> : <UnConnected />}
          <Banners />
        </div>
      </Spin>
    </Block>
  );
};

export default Banner;
